__turbopack_context__.v({
  "osPicker": "_7sMzlq_osPicker",
  "osPickerContent": "_7sMzlq_osPickerContent",
  "osPickerTab": "_7sMzlq_osPickerTab",
  "osPickerTabActive": "_7sMzlq_osPickerTabActive",
  "osPickerTabs": "_7sMzlq_osPickerTabs",
});
